import { Component } from 'react';
import { withTranslation } from 'react-i18next';


type Props = {};

type State = {};


class PrivacyStatements extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <div style={{ padding: 20 }}>
        <h1>Privacy Statement</h1>
        <p>Last updated: June 30, 2024</p>
        <p>
          Square Golf ("us", "we", or "our") operates the Square Golf website (the "Service"). This page informs you of our policies regarding the collection, use, and disclosure of personal information when you use our Service.
        </p>
        <h2>1. Information Collection and Use</h2>
        <p>
          We collect several different types of information for various purposes to provide and improve our Service to you. Types of data collected include:
        </p>
        <ul>
          <li><strong>Personal Data:</strong> While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ("Personal Data"). This may include, but is not limited to, your email address, name, and phone number.</li>
          <li><strong>Usage Data:</strong> We may also collect information on how the Service is accessed and used ("Usage Data"). This Usage Data may include information such as your computer's Internet Protocol address (e.g., IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, and other diagnostic data.</li>
        </ul>
        <h2>2. Use of Data</h2>
        <p>
          Square Golf uses the collected data for various purposes:
        </p>
        <ul>
          <li>To provide and maintain our Service</li>
          <li>To notify you about changes to our Service</li>
          <li>To allow you to participate in interactive features of our Service when you choose to do so</li>
          <li>  To provide customer support</li>
          <li>To gather analysis or valuable information so that we can improve our Service</li>
          <li>To monitor the usage of our Service</li>
          <li>To detect, prevent and address technical issues</li>
        </ul>
        <h2>3. Disclosure of Data</h2>
        <p>
          We may disclose your Personal Data in the good faith belief that such action is necessary to:
        </p>
        <ul>
          <li>To comply with a legal obligation</li>
          <li>To protect and defend the rights or property of Square Golf</li>
          <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
          <li>To protect the personal safety of users of the Service or the public</li>
          <li>To protect against legal liability</li>
        </ul>
        <h2>4. Security of Data</h2>
        <p>
          The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.
        </p>
        <h2>5. Changes to This Privacy Statement</h2>
        <p>
          We may update our Privacy Statement from time to time. We will notify you of any changes by posting the new Privacy Statement on this page. You are advised to review this Privacy Statement periodically for any changes. Changes to this Privacy Statement are effective when they are posted on this page.
        </p>
        <h2>6. Contact Us</h2>
        <p>
          If you have any questions about this Privacy Statement, please contact us at
          <a href='mailto: helpdesk@sqauregolf.com'> helpdesk@squaregolf.com </a>

        </p>
      </div>
    );
  }
}

export default withTranslation()(PrivacyStatements);
